import React, { useState, useEffect } from 'react';
import Pagination from 'react-paginate';
import ReactPaginate from 'react-paginate';
import TitleNames from '../../Component/Header/TitleNames'
import { data } from '../../Component/data'
import './QueryList.css'
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { PostAPI } from '../../common/Api';
import moment from 'moment';

const QueryList = () => {
  
  const navigate = useNavigate();
  const { queryid,query_type } = useParams()
  const [searchParams] = useSearchParams()
  var start_date = searchParams.get('start-date');
  var end_date = searchParams.get('end-date');
  console.log('searchParams',start_date,end_date)
  // alert(queryid)



  const [queryTable, setQueryTable] = useState([])

  const user_id = JSON.parse(sessionStorage.getItem('login_details')).counsellor_id;
  const [itemVal, setItemVal] = useState('')
  const handleChange = (item) => {
    setItemVal(item?.id)}

  useEffect(() => {
    let formData = new FormData();
    formData.append('id', user_id);
    formData.append('type', queryid);
    if(start_date && end_date){
      formData.append('start_date', start_date);
      formData.append('end_date', end_date);
    }
    formData.append('query_type', query_type);
    var apiData = {
      url: 'counsellor_query_list',
      data: formData
    }

    PostAPI(apiData, (res) => {
      if (res && res.status) {
        setQueryTable(res?.data)
        console.log("hsdf", res?.data)
      }
    })

  }, [])

  

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  const handlePageClick = () => {
    // console.log(queryTable)
    setCurrentPage(queryTable?.selected);
  };

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = queryTable.slice(indexOfFirstItem, indexOfLastItem);
  console.log('data', data)
  console.log('currentData', currentData)
  console.log(indexOfFirstItem, indexOfLastItem)
  // console.log("val",itemVal)

  return (
    <>
      <TitleNames />
      <div className=' container-fluid MainContentAll'>
        <h5>Query List</h5>
        <Link className='BackButnq' to="/dashboard">  <button className="btn btn btn-primary btn-rounded ArrowClass"><i class="fa fa-arrow-left"></i> Back</button></Link>
      </div>


      <div class="row table-responsive container-fluid ">
        <div className='card-box'>

          <table class="table card-body Bor_Table">

            {/* <caption>List of users</caption> */}
            <thead>
              <tr className='DetailsHeadings'>
                <th className='MainTitiles-new' scope="col">S.No</th>
                <th className='MainTitiles-new' scope="col">User Name</th>
                <th className='MainTitiles-new' scope="col">Date & Time</th>
                <th className='MainTitiles-new' scope="col">User Mode</th>
                <th className='MainTitiles-new' scope="col">What are you looking for?</th>
                <th className='MainTitiles-new' scope="col">Category 1</th>
                <th className='MainTitiles-new' scope="col">Category 2</th>
                <th className='MainTitiles-new' scope="col">Query</th>
                <th className='MainTitiles-new' scope="col">Status</th>
                <th className='MainTitiles-new' scope="col">Action</th>
              </tr>
            </thead>

            {currentData?.map((data, index) => (
              <tbody>
                <tr className='AllContentDetails'>
                  <td className='MainTitiles-new'><p  className='DetalsList'>{index + 1} </p></td>
                  <td className='MainTitiles-new'><p  className='DetalsList'>{data.user_name}</p></td>
                  <td className='MainTitiles-new'><p  className='DetalsList'>{moment(data.query_sent_on).format("DD MMM YYYY HH:mm A") }</p></td>
                  <td className='MainTitiles-new'><p  className='DetalsList'>{data.user_mode}</p></td>
                  <td className='MainTitiles-new'><p  className='DetalsList'>{data.looking_for}</p></td>
                  <td className='MainTitiles-new'><p  className='DetalsList'>{data.choice_one}</p></td>
                  <td className='MainTitiles-new'><p  className='DetalsList'>{data.choice_two}</p></td>
                  <td className='QueryDetails MainTitiles-new'><p  className='DetalsList'>{data.query}</p></td>
                  <td className='MainTitiles-new'><p  className='DetalsList'>{data.status}</p></td>
                  <td className='MainTitiles-new'><Link to={`/querydetails/${data?.id}`} className='DetalsList' onClick={()=>console.log("dfgh",data)}>
                    <p>View | Update status</p>
                    
                    </Link></td>
                </tr>
              </tbody>))}



          </table>

          <div className='PagiDetsils'>
            <p className='C0untDaetils'>Showing {indexOfFirstItem + 1} to {(queryTable?.length - indexOfLastItem) > 0 ? indexOfLastItem : queryTable?.length} of {queryTable?.length} entries</p>
            <Pagination
              pageCount={Math.ceil(queryTable?.length / itemsPerPage)}
              onPageChange={handlePageClick}
              containerClassName={"pagination FullPaginatecss"}
              activeClassName={"active"}

            />
          </div>
        </div>
      </div>
      

    </>
  )
}

export default QueryList